import React from "react";
import Vendorcard from "../components/vendor-card";
import './vendor.css'
import SearchBar from "../components/searchbar";
import { useState } from "react";

const Vendors =()=>{
    const [searchQuery, setSearchQuery] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalData, setModalData] = useState(null);

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    return (
        <div>
            <SearchBar searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
            <diV className='vendors-container'>
                <Vendorcard
                    searchQuery={searchQuery}
                    openModal={openModal}
                    setModalData={setModalData}
                />
            </diV>
            
            {/* Modal */}
            {isModalOpen && modalData && (
                <div className="modal-overlay" onClick={closeModal}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        
                        <button className="close-button" onClick={closeModal}>X</button>
                        <img src={modalData.logo}></img>
                        <h2>{modalData.name}</h2>
                        <p>{modalData.description}</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Vendors